<template>
    <div class="column-date-range">
        <datepicker v-model="from" @input="change" :disabled="{from: to}" clear-button clear-button-icon="fa fa-times" inputClass="form-control"></datepicker>
        <datepicker v-model="to" @input="change" :disabled="{to: from}" clear-button clear-button-icon="fa fa-times" inputClass="form-control"></datepicker>
    </div>
</template>
<style>
.column-date-range {
    white-space: normal;
    width:270px;
}

.column-date-range .vdp-datepicker__calendar {
    position: fixed;
    margin-left: -120px;
}

.vdp-datepicker__clear-button>i {
    margin-left: -26px;
    position: absolute;
    top: 10px;
    right: 9px;
}

.vdp-datepicker__clear-button>i>span {
    display: none;
}
.vdp-datepicker{
    display:inline-block;
    width:130px;
}
</style>
<script>
import moment from 'moment';
export default {
    props: ['column'],
    data() {
        return {
            from: null,
            to: null
        };
    },
    methods: {
        change() {
            let query = {};
            const from = this.from ? moment(this.from).format('Y-MM-DD') : '';
            const to = this.to ? moment(this.to).add(1, 'day').format('Y-MM-DD') : '';
            query['r_' + this.column.key] = [from, to].join('--');
            // Emit in format `r_start_date=2017-01-04--2017-12-24`
            // `r_start_date=2017-01-04--`
            // `r_start_date=--2017-12-24`
            this.$emit('input', query);
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/header/DateRange.vue